/**
 * Z-index buffer for modal stack management
 * Provides spacing between base modal z-index and stacked modals
 */
export const ZINDEX_BUFFER = 10
